import { ActionTypes, InstanceActions } from './types';

const initialState = {
  selectedInstanceId: null,
};

const Reducer = (state = initialState, action: InstanceActions) => {
  switch (action.type) {
    case ActionTypes.SET_SELECTED_INSTANCE_ID: {
      return {
        ...state,
        selectedInstanceId: action.instanceId,
      };
    }
    default: {
      return state;
    }
  }
};

export default Reducer;
